var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"page-container-height div-overflow"},[_c('div',{staticClass:"warehouse-title"},[_vm._v("全部仓库")]),_c('warehouseContent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }